import { IServerNotification } from '../Models/Notification';
import { ApiService } from '../_services/ApiService';

export class NotificationService extends ApiService {
    protected basePath = 'notifications';
    protected subPaths = {
        unviewedCount: 'unviewed/count',
        setAllBeforeIdAsViewed: (id: string) => `viewed?before_id=${id}`,
        setAllBeforeIdAsClicked: (id: string) => `clicked?before_id=${id}`,
        clickedNotificationID: (id: string) => `clicked/${id}`
    };

    public getUnviewedNotificationsCount(): Promise<number> {
        return this.getSubPath(this.subPaths.unviewedCount);
    }

    public async getAllNotifications(): Promise<Array<IServerNotification>> {
        return this.getRequest();
    }

    public async getRecentNotifications(limit: number): Promise<Array<IServerNotification>> {
        return this.getRequest({ limit });
    }

    public setNotifictionsBeforeIdAsViewed(notificationID: string): Promise<void> {
        return this.putSubPath(this.subPaths.setAllBeforeIdAsViewed(notificationID));
    }

    public setNotifictionsBeforeIdAsRead(notificationID: string): Promise<void> {
        return this.putSubPath(this.subPaths.setAllBeforeIdAsClicked(notificationID));
    }

    public setNotificationAsReadByID(notificationID: string): Promise<void> {
        return this.putSubPath(this.subPaths.clickedNotificationID(notificationID));
    }
}



// WEBPACK FOOTER //
// ./src/Services/NotificationService.ts